// Copyright (c) Docugami, Inc. All rights reserved.
export interface AuthenticationState {
    loginUrl: string;
    errorEncountered: boolean;
    userRolesPerOrg: { [orgId: string]: string[] } | undefined;
}

export const SET_LOGIN_URL = "SET_LOGIN_URL";
export const SET_ERROR_ENOUNTERED = "SET_ERROR_ENOUNTERED";
export const SET_USER_ROLES_PER_ORG = "SET_USER_ROLES_PER_ORG";

interface SetLoginUrl {
    type: typeof SET_LOGIN_URL;
    payload: string;
}

interface SetErrorEncountered {
    type: typeof SET_ERROR_ENOUNTERED;
    payload: boolean;
}

interface SetUserRolesPerOrg {
    type: typeof SET_USER_ROLES_PER_ORG;
    payload: { [orgId: string]: string[] };
}

export type AuthenticationActionTypes =
    SetLoginUrl |
    SetErrorEncountered |
    SetUserRolesPerOrg;
